import {
  ApiClientFactory
} from '../ApiClientFactory';
import {
  API_URL,
  API_V4_URL
} from '../Variables';

let clientFactory = new ApiClientFactory();

export const CourseClient = {
  /**
   * Returns a course with the provided id.
   *
   * @param {Integer} id
   */
  getCourse(id = '') {
    return clientFactory.get(API_V4_URL + 'courses/' + id);
  },

  /**
   * Downloads all attachments on the course.
   */
  downloadFiles() {
    return clientFactory.get(API_URL + 'attachments/download');
  },

  /**
   * Returns all courses related to a user.
   */
  getCourses() {
    return clientFactory.get(API_V4_URL + 'courses');
  },

  /**
   * Returns all projects related to a user.
   */
  getProjects() {
    return clientFactory.get(API_URL + 'projects');
  },

  /**
   * Return a single project
   */
  getProject(groupId, userId, projectId) {
    return clientFactory.get(API_URL +
      'projects/' + groupId + '/' + userId + '/' + projectId
    );
  },
  /**
   * Returns a course lesson.
   *
   * @param {Integer} courseId
   * @param {Integer} unitId
   * @param {Integer} lessonId
   */
  getLesson(courseId, unitId, lessonId) {
    return clientFactory.get(API_V4_URL +
      'courses/' + courseId + '/modules/' + unitId + '/lessons/' + lessonId
    );
  },
  completeLesson(courseId, unitId, lessonId) {
    return clientFactory.post(API_V4_URL +
      'courses/' +
      courseId +
      '/modules/' +
      unitId +
      '/lessons/' +
      lessonId +
      '/complete',
      null
    );
  },
  getGlossaryTerm(termId) {
    return clientFactory.get(API_URL + 'glossary/' + termId);
  },
};
